<script setup lang="ts">
import { PV } from "@/widgets";
import type { defineState } from "../common";

const props = defineProps<{
    text?: string;
    state: ReturnType<typeof defineState>;
}>();
</script>

<template>
    <PV.Message
        v-if="props.text !== undefined && !props.state.hasError"
        class="pl-1"
        severity="secondary"
        size="small"
        variant="simple"
    >
        {{ props.text }}
    </PV.Message>
</template>
